/**
 * FASE E.2 Turno 3 — Shared constants for Admin Case Editor.
 *
 * Extracted 1-to-1 from Wizard.jsx so the Admin Editor uses the SAME enums,
 * date semantics and structural flags. NO methodology changes here — this
 * module only mirrors the option lists the Wizard already exposes.
 */

export const DOC_TYPES = [
  { v: "firma_singola", l: "Firma singola" },
  { v: "piu_firme", l: "Più firme sullo stesso documento" },
  { v: "testamento_olografo", l: "Testamento olografo" },
  { v: "manoscritto_intero", l: "Intero manoscritto" },
  { v: "sigla", l: "Sigla / paraffe" },
  { v: "compilazione_manoscritta", l: "Compilazione manoscritta" },
  { v: "firma_bancaria", l: "Firma su documento bancario" },
  { v: "firma_grafometrica", l: "Firma grafometrica / digitale" },
];

export const QDOC_ROLES = [
  { v: "principale", l: "Principale" },
  { v: "secondario", l: "Secondario" },
  { v: "accessorio", l: "Accessorio" },
];

export const QDOC_ORIGINAL_STATUS = [
  { v: "existing_available", l: "Originale esistente e disponibile" },
  { v: "existing_not_available", l: "Originale esistente ma non disponibile" },
  { v: "existence_not_verified", l: "Esistenza dell'originale non verificata" },
  { v: "not_existing", l: "Originale non esistente" },
  { v: "unknown", l: "Dato non noto" },
];

export const QDOC_MATERIAL = [
  { v: "originale", l: "Originale" },
  { v: "scansione_colori", l: "Scansione a colori" },
  { v: "scansione_bn", l: "Scansione in bianco e nero" },
  { v: "fotocopia_colori", l: "Fotocopia a colori" },
  { v: "fotocopia_bn", l: "Fotocopia in bianco e nero" },
  { v: "fotografia", l: "Fotografia" },
  { v: "riproduzione_digitale", l: "Riproduzione digitale" },
  { v: "non_disponibile", l: "Non disponibile" },
  { v: "altro", l: "Altro" },
];

export const SOURCE_MATERIALS = [
  { v: "originale", l: "Originale disponibile" },
  { v: "originale_non_acquisito", l: "Originale esistente ma non acquisito" },
  { v: "scansione_colori", l: "Scansione a colori" },
  { v: "scansione_bn", l: "Scansione in bianco e nero" },
  { v: "fotografia", l: "Fotografia" },
  { v: "fotocopia_colori", l: "Fotocopia a colori" },
  { v: "fotocopia_bn", l: "Fotocopia in bianco e nero" },
  { v: "stampa", l: "Stampa" },
  { v: "formato_sconosciuto", l: "Formato sconosciuto" },
];

export const DATE_PRECISION_OPTIONS = [
  { v: "exact", l: "Data esatta" },
  { v: "month_year", l: "Mese e anno" },
  { v: "year_only", l: "Solo anno" },
  { v: "estimated", l: "Data stimata" },
  { v: "unknown", l: "Data non nota" },
];

export const ASSISTED_PARTY_ROLES = [
  { v: "attore", l: "Attore" },
  { v: "convenuto", l: "Convenuto" },
  { v: "ricorrente", l: "Ricorrente" },
  { v: "resistente", l: "Resistente" },
  { v: "appellante", l: "Appellante" },
  { v: "appellato", l: "Appellato" },
  { v: "opponente", l: "Opponente" },
  { v: "opposto", l: "Opposto" },
  { v: "querelante", l: "Querelante" },
  { v: "querelato", l: "Querelato" },
  { v: "parte_istante", l: "Parte istante" },
  { v: "parte_chiamata", l: "Parte chiamata" },
  { v: "erede", l: "Erede" },
  { v: "beneficiario", l: "Beneficiario" },
  { v: "contestatore", l: "Contestatore" },
  { v: "parte_producente", l: "Parte producente" },
  { v: "parte_opposta", l: "Parte opposta" },
  { v: "non_ancora_definita", l: "Non ancora definita" },
  { v: "altro", l: "Altro" },
];

export const PRIVATE_CASE_ROLES = [
  { v: "persona_scrivente", l: "Persona cui è attribuita la firma" },
  { v: "erede", l: "Erede" },
  { v: "beneficiario", l: "Beneficiario" },
  { v: "parte_contesta", l: "Parte che contesta il documento" },
  { v: "parte_sostiene", l: "Parte che sostiene l'autenticità" },
  { v: "altro", l: "Altro" },
];

export const LEGAL_TITLES = [
  { v: "Avv.", l: "Avv." },
  { v: "Dott.", l: "Dott." },
  { v: "Dott.ssa", l: "Dott.ssa" },
  { v: "Altro", l: "Altro" },
];

export const PHASE_OPTIONS = [
  { v: "stragiudiziale", l: "Stragiudiziale" },
  { v: "mediazione_obbligatoria", l: "Mediazione obbligatoria" },
  { v: "giudiziale", l: "Giudiziale" },
  { v: "appello", l: "Appello" },
];

export const SIGNATURE_STATUS_OPTIONS = [
  { v: "riconosciuta", l: "Riconosciuta" },
  { v: "disconosciuta", l: "Disconosciuta" },
  { v: "non_conosciuta", l: "Non conosciuta" },
];

export const TIMELINE_MACROS = [
  { v: "documento_verifica", l: "Evento riguardante il documento in verifica" },
  { v: "processuale", l: "Evento processuale o stragiudiziale" },
  { v: "personale", l: "Evento personale o contestuale" },
  { v: "altro", l: "Altro" },
];

export const CLINICAL_DOC_TYPES = [
  { v: "cartella_clinica_completa", l: "Cartella clinica completa" },
  { v: "cartella_clinica_parziale", l: "Cartella clinica parziale" },
  { v: "lettera_dimissione", l: "Lettera di dimissione" },
  { v: "certificato_medico", l: "Certificato medico" },
  { v: "referto", l: "Referto specialistico" },
  { v: "visita_neurologica", l: "Visita neurologica" },
  { v: "visita_ortopedica", l: "Visita ortopedica" },
  { v: "visita_geriatrica", l: "Visita geriatrica" },
  { v: "visita_psichiatrica", l: "Visita psichiatrica" },
  { v: "visita_oculistica", l: "Visita oculistica" },
  { v: "esame_diagnostico", l: "Esame diagnostico" },
  { v: "piano_terapeutico", l: "Piano terapeutico" },
  { v: "farmacologica", l: "Documentazione farmacologica" },
  { v: "riabilitativa", l: "Documentazione riabilitativa" },
  { v: "medico_curante", l: "Certificazione medico curante" },
  { v: "altro", l: "Altro" },
];

export const CLINICAL_CONDITIONS = [
  "tremore", "Parkinson", "ictus", "demenza", "Alzheimer",
  "patologie neurologiche", "patologie psichiatriche", "deficit motori",
  "artrosi grave", "fratture", "interventi chirurgici", "ricoveri",
  "terapie farmacologiche rilevanti", "sedazione", "condizioni non conosciute",
];

// FASE E.2 Turno 3 — Stable ID generator for dynamic list items.
// MUST be identical to Wizard.jsx (`_mkId`) so revision diffs remain stable.
export function mkId(prefix) {
  const rnd = (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID().slice(0, 8)
    : Math.random().toString(36).slice(2, 10);
  return `${prefix}_${Date.now().toString(36)}_${rnd}`;
}

// FASE E.2 Turno 3 — Human-readable path → Italian label mapping used by the
// diff modal. Extend this as needed; unknown paths fall back to the raw path
// with a "codice interno" annotation so admins never see naked JSON paths.
export const FIELD_LABELS = {
  "role": "Percorso (ruolo utente)",
  "requester.first_name": "Richiedente — Nome",
  "requester.last_name": "Richiedente — Cognome",
  "requester.title": "Richiedente — Titolo",
  "requester.organization": "Richiedente — Studio/Organizzazione",
  "requester.email": "Richiedente — E-mail",
  "requester.phone": "Richiedente — Telefono",
  "assisted_party.first_name": "Parte assistita — Nome",
  "assisted_party.last_name": "Parte assistita — Cognome",
  "assisted_party.role": "Parte assistita — Posizione processuale",
  "assisted_party.role_other": "Parte assistita — Posizione (altro)",
  "case_short_description": "Descrizione breve del caso",
  "identification.subject.name": "Scrivente — Nome",
  "identification.subject.first_name": "Scrivente — Nome (proprio)",
  "identification.subject.last_name": "Scrivente — Cognome",
  "identification.subject.dob": "Scrivente — Data di nascita",
  "identification.subject.deceased_date": "Scrivente — Data di decesso",
  "identification.subject_dob": "Scrivente — Data di nascita",
  "identification.subject_age_years": "Scrivente — Età dichiarata",
  "identification.laterality": "Scrivente — Lateralità",
  "identification.uses_glasses": "Scrivente — Uso di occhiali",
  "identification.visual_issues": "Scrivente — Problemi visivi",
  "identification.visual_notes": "Scrivente — Note visive",
  "identification.document_type": "Documento #1 — Tipo",
  "identification.title": "Documento #1 — Denominazione",
  "identification.role": "Documento #1 — Ruolo",
  "identification.material_support": "Documento #1 — Supporto materiale",
  "identification.original_status": "Documento #1 — Stato originale",
  "identification.document_availability": "Documento #1 — Disponibilità",
  "identification.contested_document_date": "Documento #1 — Data",
  "identification.original_holder": "Documento #1 — Custode",
  "identification.disputed_signature_count": "Documento #1 — N° firme contestate",
  "identification.contains_handwritten_text": "Documento #1 — Testo manoscritto",
  "identification.contains_handwritten_numbers": "Documento #1 — Numeri manoscritti",
  "identification.contains_initials": "Documento #1 — Sigle/paraffe",
  "identification.contains_full_signature": "Documento #1 — Firma per esteso",
  "identification.contains_multiple_signatures": "Documento #1 — Più firme",
  "identification.contains_multiple_writers": "Documento #1 — Più scriventi",
  "identification.contested_area_description": "Documento #1 — Zona contestata",
  "identification.notes": "Documento #1 — Note",
  "identification.phase": "Contesto — Fase procedurale",
  "identification.already_in_court": "Contesto — Prodotto in giudizio",
  "identification.disconoscimento": "Contesto — Disconoscimento avvenuto",
  "identification.mediazione_obbligatoria": "Contesto — Mediazione obbligatoria",
  "comparatives.period_covered_years": "Comparative — Periodo coperto (anni)",
  "comparatives.already_verified_documents": "Comparative — Documenti già verificati",
  "legal_strategy.producing_party": "Strategia — Parte producente",
  "legal_strategy.against_party": "Strategia — Parte contraria",
  "legal_strategy.signature_status": "Strategia — Stato sottoscrizione",
  "legal_strategy.deadline_notes": "Strategia — Termini processuali",
  "legal_strategy.verificazione_requested": "Strategia — Istanza verificazione",
  "legal_strategy.querela_falso": "Strategia — Querela di falso",
  "legal_strategy.ctu_disposed": "Strategia — CTU disposta",
  "legal_strategy.disconoscimento_dichiarazione": "Strategia — Dichiarazione disconoscimento",
  "legal_strategy.disconoscimento_note": "Strategia — Note disconoscimento",
  "clinical.notes": "Clinico — Note",
  "clinical.conditions": "Clinico — Condizioni dichiarate",
};

// Human-readable label for a value depending on the field path.
export function humanizeValue(path, v) {
  if (v === null || v === undefined || v === "") return "— vuoto —";
  if (v === true) return "Sì";
  if (v === false) return "No";
  if (Array.isArray(v)) {
    if (v.length === 0) return "— nessun elemento —";
    return `${v.length} elemento/i`;
  }
  if (typeof v === "object") {
    return JSON.stringify(v);
  }
  // Enum → label lookups
  const enumMaps = {
    "identification.document_type": DOC_TYPES,
    "identification.material_support": QDOC_MATERIAL,
    "identification.original_status": QDOC_ORIGINAL_STATUS,
    "identification.role": QDOC_ROLES,
    "identification.phase": PHASE_OPTIONS,
    "assisted_party.role": [...ASSISTED_PARTY_ROLES, ...PRIVATE_CASE_ROLES],
    "legal_strategy.signature_status": SIGNATURE_STATUS_OPTIONS,
    "requester.title": LEGAL_TITLES,
  };
  const map = enumMaps[path];
  if (map) {
    const hit = map.find((o) => o.v === v);
    if (hit) return hit.l;
  }
  return String(v);
}

export function humanizeFieldPath(path) {
  if (FIELD_LABELS[path]) return FIELD_LABELS[path];
  // Handle list-index paths e.g. questioned_documents[2].title
  const listMatch = path.match(/^([a-z_]+)\[(\d+)\](?:\.(.*))?$/);
  if (listMatch) {
    const [, container, idx, sub] = listMatch;
    const containerLabels = {
      questioned_documents: "Documento in verifica",
      timeline: "Evento cronologia",
      "comparatives.comparatives": "Comparativa",
      "clinical.documents": "Documento sanitario",
      "clinical.ricoveri": "Ricovero",
      "clinical.conditions": "Condizione clinica",
    };
    const label = containerLabels[container] || container;
    const n = String(Number(idx) + 1).padStart(2, "0");
    if (!sub) return `${label} #${n}`;
    // Try sub-path shortcut labels (only common ones)
    const subShortcuts = {
      title: "denominazione", role: "ruolo",
      document_type: "tipo", date_value: "data",
      date_precision: "precisione data", date_text: "data (testo)",
      date_year: "anno", date_month: "mese",
      material_support: "supporto", original_status: "stato originale",
      custodian: "custode", notes: "note",
      contains_handwritten_text: "testo manoscritto",
      contains_handwritten_numbers: "numeri manoscritti",
      contains_initials: "sigle/paraffe",
      contains_full_signature: "firma per esteso",
      contains_multiple_signatures: "più firme",
      contains_multiple_writers: "più scriventi",
      disputed_signature_count: "n° firme contestate",
      contested_area_description: "zona contestata",
      event_macro: "macro-tipo", event_subtype: "sottotipo",
      description: "descrizione", location: "luogo", source: "fonte",
      date: "data", is_original: "originale", is_official: "ufficiale",
      contains_signature: "contiene firma", contains_text: "contiene testo",
      contains_numbers: "contiene numeri",
      certainly_attributable: "attribuibile con certezza",
      year: "anno",
      type: "tipo", type_label: "tipo (etichetta)",
      title: "titolo", outcome: "esito", event_description: "evento descritto",
      structure: "struttura", start_date: "data inizio", end_date: "data fine",
      documentation_available: "docs disponibili",
    };
    return `${label} #${n} — ${subShortcuts[sub] || sub}`;
  }
  // Fallback: last segment title-cased
  const segs = path.split(".");
  const last = segs[segs.length - 1];
  return last.replace(/_/g, " ");
}
